export const LOAD_HEADING_WORKFLOW_REQUESTED = "HEADING_WORKFLOW/LOAD_HEADING_WORKFLOW_REQUESTED";
export const LOAD_HEADING_WORKFLOW_SUCCESS = "HEADING_WORKFLOW/LOAD_HEADING_WORKFLOW_SUCCESS";
export const LOAD_HEADING_WORKFLOW_FAIL = "HEADING_WORKFLOW/LOAD_HEADING_WORKFLOW_FAIL";

export const SAVE_HEADING_WORKFLOW_REQUESTED = "HEADING_WORKFLOW/SAVE_HEADING_WORKFLOW_REQUESTED";
export const SAVE_HEADING_WORKFLOW_SUCCESS = "HEADING_WORKFLOW/SAVE_HEADING_WORKFLOW_SUCCESS";
export const SAVE_HEADING_WORKFLOW_FAIL = "HEADING_WORKFLOW/SAVE_HEADING_WORKFLOW_FAIL";

export const LOAD_HEADING_WORKFLOW_CURRENTUSER_REQUESTED = "HEADING_WORKFLOW/LOAD_HEADING_WORKFLOW_CURRENTUSER_REQUESTED";
export const LOAD_HEADING_WORKFLOW_CURRENTUSER_SUCCESS = "HEADING_WORKFLOW/LOAD_HEADING_WORKFLOW_CURRENTUSER_SUCCESS";

export default (
    state = {
        loading: 0,
        headingWorkflow: {},
        errors: [],
        hasInitialData: false,
        currentUser: {}
    },
    { type, data }
) => {
    switch (type) {
        case LOAD_HEADING_WORKFLOW_REQUESTED: {
            ++state.loading;
            return state;
        }
        case LOAD_HEADING_WORKFLOW_SUCCESS: {
            --state.loading;
            state.hasInitialData = true;
            state.headingWorkflow = data;
            return state;
        }
        case LOAD_HEADING_WORKFLOW_FAIL: {
            --state.loading;
            state.errors.push({ error: data, type });
            return state;
        }
        case SAVE_HEADING_WORKFLOW_REQUESTED: {
            ++state.loading;
            return state;
        }
        case SAVE_HEADING_WORKFLOW_SUCCESS: {
            --state.loading;
            state.headingWorkflow = data;
            state.hasInitialData = true;
            return state;
        }
        case SAVE_HEADING_WORKFLOW_FAIL: {
            --state.loading;
            state.errors.push({ error: data, type });
            return state;
        }
        case LOAD_HEADING_WORKFLOW_CURRENTUSER_REQUESTED: {
            ++state.loading;
            return state;
        }
        case LOAD_HEADING_WORKFLOW_CURRENTUSER_SUCCESS: {
            --state.loading;
            state.currentUser = data;
            return state;
        }
        default:
            return state;
    }
};

export const requestLoadHeadingWorkflow = data => ({ type: LOAD_HEADING_WORKFLOW_REQUESTED, data });
export const successLoadHeadingWorkflow = data => ({ type: LOAD_HEADING_WORKFLOW_SUCCESS, data });
export const failLoadHeadingWorkflow = data => ({ type: LOAD_HEADING_WORKFLOW_FAIL, data });

export const requestSaveHeadingWorkflow = data => ({ type: SAVE_HEADING_WORKFLOW_REQUESTED, data });
export const successSaveHeadingWorkflow = data => ({ type: SAVE_HEADING_WORKFLOW_SUCCESS, data });
export const failSaveHeadingWorkflow = data => ({ type: SAVE_HEADING_WORKFLOW_FAIL, data });

export const requestLoadCurrentUser = (data,resolve,reject)=>({type:LOAD_HEADING_WORKFLOW_CURRENTUSER_REQUESTED,data,resolve,reject});
export const successLoadCurrentUser = data => ({ type: LOAD_HEADING_WORKFLOW_CURRENTUSER_SUCCESS, data });